import React, {  forwardRef } from 'react';
import PropTypes from 'prop-types';



// material
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  DialogActions,
  Slide,
  Box,
  Typography
} from '@mui/material';



/* eslint-disable */
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/* eslint-enable */



 function AlertDialog({ openAlertDialog, message, title, btnLabel, handleClose }) {



  

  return (
      <Dialog
        open={openAlertDialog}
        sx={{ zIndex: 10000000 }}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        data-testId = 'Alert_Dialog'
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent data-testid='alert-dialog-content'>
          <DialogContentText id="alert-dialog-slide-description">

            {(() => {
              if (Array.isArray(message)) {
                return <>
                  {
                    message?.map((merchant,index) => (
                      <Box sx={{p:2}} key={merchant}>
                        <Typography sx={{fontWeight:700,color:"rgba(195, 10, 10, 1)"}}>{merchant}</Typography>
                      </Box>
                    ))}
                </>
              } 
              if (typeof message === 'object' && message !== null && message!==undefined){
                const objectKeys = Object.keys(message);
                return <>
                  {
                     objectKeys?.map((k) => (
                      <Box sx={{p:2}} key={k}>
                        <Typography sx={{fontWeight:700,color:"rgba(195, 10, 10, 1)"}}>{k} : {message[k]}</Typography>
                      </Box>
                    ))}
                </>
              }
              return <Typography>{message}</Typography>
            })()}


          </DialogContentText>
        </DialogContent>
        <DialogActions>

          <Button data-testid='submit-button' onClick={handleClose}>OK</Button>
        </DialogActions>
      </Dialog>

  );
}



export default AlertDialog;